// extracted by mini-css-extract-plugin
export var footer = "_ne-5";
export var fulfillmentInput = "_ne-0";
export var shipDateInput = "_ne-1";
export var shipmentModal = "_ne-2";
export var shipmentModalContent = "_ne-3";
export var tableContainer = "_ne-4";